// @js-import "@common/common-dependencies.js"
// @js-import "@shared/height.js"
// @js-import "@shared/accordion.js"
// @js-import "@shared/tabs.js"


ComponentsManager.register('tabs_advanced', function() {
    const { td120 } = rwd.timeoutDelay;
    var ScreenSize = rwd.ScreenSize;
    var Tabs = rwd.Tabs;
    var privateMethod = {
        htmlElements: {
            modeAccordion: '.transformation_accordion',
        },
        isMobileAccordion: function(component) {
            return (!deviceUtils.isDesktop && component.find(this.htmlElements.modeAccordion).exists());
        },
        transformToAccordion: function($componentElement) {
            const Accordion = rwd.Accordion;
            function accordionOnCondition() {
                return privateMethod.isMobileAccordion($componentElement)
            }
            new Accordion(Accordion.makeAccordion($componentElement.find("> .wrapper .tabs_items")), {
                onCondition: accordionOnCondition
            });
        },
        runIntegerAnimationItem: function($componentElement) {
            if (!this.isMobileAccordion($componentElement)) {
                rwd.integerAnimationItem.run($componentElement.find(".tab_menuItem"), "active");
            }
        },
        preventAddingFocusOnClickForActiveTab: function($componentElement) {
            const $activeTab = $componentElement.find('.tabs_item');
            let mousedown = false;
            let keydown = false;
            const clearValues = () => {
                mousedown = false;
                keydown = false;
            };
            $(document).on('keydown', function() {
                setTimeout(clearValues);
                keydown = true;
            });
            $activeTab.on('mousedown', function() {
                setTimeout(clearValues);
                mousedown = true;
            });
            $activeTab.on('focus', function() {
                const isPrecedingEvent = mousedown || keydown;
                if (mousedown || !isPrecedingEvent) {
                    $(this).addClass('isMouseFocused');
                }
            });
            $activeTab.on('blur', function() {
                $(this).removeClass('isMouseFocused');
            });
        },
        isTabsAccordionVariant: function(component) {
            const tabMenu = component[0].querySelector('.tabs_menu');
            const isTabsAccordionVariant = tabMenu.querySelector('.accordion');
            return isTabsAccordionVariant ? true : false;
        },
        addAttributesForAccessibility: function($componentElement) {
            if (deviceUtils.isDesktop) {
                const tabs = $componentElement.find('[role="tab"]').toArray();
                const tabpanels = $componentElement.find('[role="tabpanel"]').toArray();

                for (let t = 0; t < tabs.length; t++) {
                    tabpanels[t].setAttribute('tabindex', '0');;
                };
            }
        },
        scrollToDesignatedTab: function(offset, tabMenu) {
            const tabMenuStyles = window.getComputedStyle(tabMenu);
            const tabMenuMarginLeft = parseInt(tabMenuStyles.marginLeft);
            const chevronWidth = 32;
            tabMenu.scrollLeft = (offset - chevronWidth) - tabMenuMarginLeft;
        },
        animateScroll: function(element, component) {
            const slider = component[0].querySelector('.slider');
            const offset = element.offsetLeft;
            const activeTab = element.getBoundingClientRect();
            const activeTabWidth = activeTab.width;
            slider.style.transform = `translateX(${offset}px)`;
            slider.style.width = `${activeTabWidth}px`;
            slider.style.transition = '.3s';
        },
        animateActiveTab: function(element, component) {
            const tabMenu = component[0].querySelector('.tabs_menu');
            const offset = element.offsetLeft;
            privateMethod.scrollToDesignatedTab(offset, tabMenu);
            privateMethod.animateScroll(element, component)
        },
        reInitTabsOnResizeWindow: function(component) {
            const nodeList = component[0].querySelectorAll('.tab_menuItem');
            window.addEventListener('resize', () => {
                const activeElement = [...nodeList].find(tab => tab.classList.contains('active'));
                privateMethod.animateActiveTab(activeElement, component);
                privateMethod.manageTabs(component);
            })
        },
        setInitialSlider: function(nodeList, slider) {
            const activeElement = [...nodeList].find(tab => tab.classList.contains('active'));
            const activeTabWidth = activeElement.getBoundingClientRect().width;
            const activeTabLeft = activeElement.offsetLeft;
            slider.style.width = `${activeTabWidth}px`;
            slider.style.transition = 'none';
            slider.style.transform = `translateX(${activeTabLeft}px)`;
        },
        setChevronVisibility: function(component, element, scrollEnd) {
            const displayVariant = scrollEnd ? 'none' : 'block';
            element.style.display = displayVariant;
        },

        manageTabs: function(component) {
            const tabMenu = component[0].querySelector('.tabs_menu');
            const isTabMenuScrollable = tabMenu.scrollWidth > tabMenu.clientWidth;
            const nodeList = component[0].querySelectorAll('.tab_menuItem');
            const slider = component[0].querySelector('.slider');
            const rightChevron = component[0].querySelector('.tabs_advanced__chevron--right');
            const leftChevron = component[0].querySelector('.tabs_advanced__chevron--left');

            if(privateMethod.isTabsAccordionVariant(component)) {
                privateMethod.runIntegerAnimationItem(component);
            } else {
                privateMethod.setInitialSlider(nodeList, slider);
                if(deviceUtils.isMobile || isTabMenuScrollable) {
                    const marginOffset = 18;
                    function updateChevronVisibility() {
                        const isAtRightEnd = tabMenu.scrollLeft + marginOffset >= tabMenu.scrollWidth - tabMenu.clientWidth;
                        const isAtLeftEnd = tabMenu.scrollLeft <= 0;

                        privateMethod.setChevronVisibility(component[0], rightChevron, isAtRightEnd);
                        privateMethod.setChevronVisibility(component[0], leftChevron, isAtLeftEnd);
                    }
                    updateChevronVisibility();
                    rightChevron.addEventListener('click', function () {
                        tabMenu.scrollLeft += 25;
                        updateChevronVisibility();
                    });

                    leftChevron.addEventListener('click', function () {
                        tabMenu.scrollLeft -= 25;
                        updateChevronVisibility();
                    });

                    tabMenu.addEventListener('scroll', function () {
                        updateChevronVisibility();
                    });
                }
                else {
                    privateMethod.setChevronVisibility(component[0], rightChevron, 'none');
                    privateMethod.setChevronVisibility(component[0], leftChevron, 'none');
                }
            }
        },
        keyboardSupportforClassicMode: function($componentElement, parametersTabID) {
            if (!this.isMobileAccordion($componentElement)) {
                const componentTabs = $componentElement.find('[role="tab"]').toArray();
                // We define the direction
                var direction = {
                    37: -1,
                    38: -1,
                    39: 1,
                    40: 1
                };

                // Handle keydown on tabs
                function keydownEventListener (event) {
                    switch (event.keyCode) {
                        case KeypressUtils.END:
                            // Activate last tab
                            event.preventDefault();
                            focusLastTab();
                            break;
                        case KeypressUtils.HOME:
                            event.preventDefault();
                            // Activate first tab
                            focusFirstTab();
                            break;
                        case KeypressUtils.SPACE:
                            event.preventDefault();
                            break;
                    };
                };

                // Handle keyup on tabs
                function keyupEventListener (event) {
                    $componentElement.find(".tab_menuItem").each(() => $(this).removeClass('active_onMouse_click'));
                    switch (event.keyCode) {
                        case KeypressUtils.LEFTARROW:
                            switchTabOnArrowPress(event);
                            break;
                        case KeypressUtils.RIGHTARROW:
                            switchTabOnArrowPress(event);
                            break;
                        case KeypressUtils.ENTER:
                        case KeypressUtils.SPACE:
                            event.preventDefault();
                            activateTab(event.target);
                            break;
                    };
                };

                function switchTabOnArrowPress(event) {
                    const pressedKeyCode = event.keyCode;
                    if (!direction[pressedKeyCode]) return;

                    const targetTab = event.target;
                    const tabMenu = $componentElement[0].querySelector('.tabs_menu');
                    const isTabMenuScrollable = tabMenu.scrollWidth > tabMenu.clientWidth;

                    if (targetTab.index === undefined) return;

                    const newIndex = targetTab.index + direction[pressedKeyCode];
                    if (componentTabs[newIndex]) {
                        focusTab(newIndex, tabMenu, isTabMenuScrollable);
                    } else {
                        handleEdgeTabNavigation(pressedKeyCode, tabMenu, isTabMenuScrollable);
                    }
                }

                function focusTab(index, tabMenu, isTabMenuScrollable) {
                    componentTabs[index].focus();
                    if (!privateMethod.isTabsAccordionVariant($componentElement)) {
                        maybeScrollToTab(index, tabMenu, isTabMenuScrollable);
                    }
                }

                function handleEdgeTabNavigation(pressed, tabMenu, isTabMenuScrollable) {
                    if (pressed === KeypressUtils.LEFTARROW || pressed === KeypressUtils.UP) {
                        focusLastTab();
                        maybeScrollToTab(componentTabs.length - 1, tabMenu, isTabMenuScrollable);
                    } else if (pressed === KeypressUtils.RIGHTARROW || pressed === KeypressUtils.DOWN) {
                        focusFirstTab();
                        maybeScrollToTab(0, tabMenu, isTabMenuScrollable);
                    }
                }
                function maybeScrollToTab(index, tabMenu, isTabMenuScrollable) {
                    if (deviceUtils.isMobile || isTabMenuScrollable) {
                        const offset = componentTabs[index].offsetLeft;
                        privateMethod.scrollToDesignatedTab(offset, tabMenu);
                    }
                }

                // Activates any given tab panel
                function activateTab (tab, setFocus) {
                    setFocus = (setFocus === undefined) ? true : setFocus;
                    // Deactivate all other tabs
                    deactivateTabs();
                    // Set the tab as selected
                    tab.setAttribute('aria-selected', 'true');
                    tab.setAttribute('tabindex', '0');
                    tab.classList.add('active');
                    if(!tab.classList.contains('accordion')) {
                        privateMethod.animateActiveTab(tab, $componentElement);
                    }

                    const indexTab = tab.index + 1;
                    TabsControl.setTab(parametersTabID, indexTab);

                    // Set focus when required
                    if (setFocus) {
                        tab.focus();
                    } else {
                        if(tab.classList.contains('accordion')) {
                            rwd.integerAnimationItem.run($componentElement.find(".tab_menuItem"), "active");
                        }
                    };

                };

                // Deactivate all tabs and tab panels
                function deactivateTabs () {
                    for (t = 0; t < componentTabs.length; t++) {
                        componentTabs[t].setAttribute('tabindex', '-1');
                        componentTabs[t].classList.remove('active');
                        componentTabs[t].setAttribute('aria-selected', 'false');
                    };
                };

                // Make a guess
                function focusFirstTab () {
                    componentTabs[0].focus();
                };

                // Make a guess
                function focusLastTab () {
                    componentTabs[componentTabs.length - 1].focus();
                };
                // Podpięcie lisenerów
                $componentElement.find(".tab_menuItem").each(function(index) {
                    var $this = $(this);
                    $this.onPage('click', () => {
                        activateTab($this[0], false);
                    });
                    $this.onPage("keydown", keydownEventListener);
                    $this.onPage("keyup", keyupEventListener);
                    componentTabs[index].index = index;
                });
                //Dodanie zdarzenia, które nasłuchuje na zmianę w url podczas przechodzenia między elementami na stronie
                // i na tej podstawie poprawnie styluje taby
                $(window).onPage("cms-location-change", () => {
                    $componentElement.find(".tab_menuItem").each(function(index) {
                        var $this = $(this);
                        setTimeout(() => {
                            if(!$this.hasClass('active')) {
                                $this.attr('tabindex', '-1')
                                $this.attr('aria-selected', 'false');
                            }
                        }, td120)
                    });
                });
            }
        }
    };

    return {
        init: function(componentId, $componentElement, jsParameters) {
            // Kod ponizej robi zasadniczo to samo co TabsControl.setDefaultTab ale tam jest ustawiany TabsControl.tabs
            // po nazwie i wtedy cały zbędny kod z TabsControl sie aktywuje dla naszych zakładek i ostro przeszkadza.
            //
            // czytamy numer zakładki z hash
            const parametersTabID = jsParameters.tabId

            TabsControl.defaultTab[parametersTabID] = jsParameters.defaultTab;
            var tabNo = TabsControl.getHashTabNo(parametersTabID);
            if (tabNo === -1) {
                // gdy nie ma info w hash to otwieramy domyślną zakładkę
                tabNo = jsParameters.defaultTab;
            }
            // taby w hash sa numerowane od 1 a wewnetrznie zapamietujemy default jako index
            new Tabs($componentElement.find("> .wrapper")[0], jsParameters.tabId,{
                onCondition: function() {
                    return privateMethod.isMobileAccordion($componentElement) ? false : true;
                },
                expanded: tabNo - 1
            });
            HashControl.init();

            /* Accordion type */
            privateMethod.transformToAccordion($componentElement);

            /* Prevent adding focus on click for the active tab,*/
            privateMethod.preventAddingFocusOnClickForActiveTab($componentElement);

            /* Add attributes for accessibility */
            privateMethod.addAttributesForAccessibility($componentElement);

            /* keyboard Support */
            privateMethod.keyboardSupportforClassicMode($componentElement, parametersTabID);

            /*A consolidated function to manage the handling of tabs specifically for the Tabs variant, in compliance with the WCAG changes */
            privateMethod.manageTabs($componentElement);

            /*plugin Changelog */
            ckEditorPluginChangelog();

            $(window).onPage(ScreenSize.SIZE_CHANGE_EVENT_NAME, function() {
                /* Checking the tabs variant and triggering the function with the old animation for the Accordion version from Baśka's portal */
                if(privateMethod.isTabsAccordionVariant($componentElement)) {
                    privateMethod.runIntegerAnimationItem($componentElement);
                } else {
                    privateMethod.reInitTabsOnResizeWindow($componentElement);
                }
                privateMethod.keyboardSupportforClassicMode($componentElement, parametersTabID);
            });
        }
    }
});
